export default __webpack_public_path__ + "refresh-page-option.png";